var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"outlined":""}},[_c('v-card-title',[_vm._v("\n    Bank Reconcile\n  ")]),_vm._v(" "),_c('v-card-text')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }